import { useState, useContext } from "react";
import clienteAxios from "../../config/axios";
import AlertaContext from "../../Context/Alerta/AlertaContext";
import { itemDefault } from "./constants";
import useCRUDTable from "../components/newFormat/useCRUDTable";

const fetchImpresoras = async ({ page, cantidad, input, orden, search }) => {
  const res = await clienteAxios.post("/impresoras/pagination", {
    page,
    cantidad,
    input,
    orden,
    search: search  ,
  });
  console.log({ res });

  return res.data?.data ?? res.data;
};

const validarImpresora = (data) => {
  const errores = {};
  if (!data.imp_nombre?.trim()) errores.imp_nombre = true;
  if (!data.imp_ip?.trim()) errores.imp_ip = true;
  return errores;
};

const useImpresora = () => {
  const { mostrarAlerta } = useContext(AlertaContext);

  const table = useCRUDTable({
    fetchFn: fetchImpresoras,
    defaultSort: "imp_nombre",
    onError: () => mostrarAlerta("Error al cargar impresoras", "error"),
  });

  const [openNuevo, setOpenNuevo] = useState(false);
  const [nuevo, setNuevo] = useState({ ...itemDefault });
  const [guardando, setGuardando] = useState(false);
  const [errores, setErrores] = useState({});

  const [editandoId, setEditandoId] = useState(null);
  const [editando, setEditando] = useState({ ...itemDefault });
  const [erroresEdit, setErroresEdit] = useState({});

  const [eliminando, setEliminando] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState({ open: false, id: null });

  const handleRegistrar = async () => {
    const erroresValidacion = validarImpresora(nuevo);
    if (Object.keys(erroresValidacion).length > 0) {
      setErrores(erroresValidacion);
      return;
    }

    setErrores({});
    setGuardando(true);
    try {
      const payload = {
        imp_nombre: nuevo.imp_nombre.trim(),
        imp_ip: nuevo.imp_ip.trim(),
      };
      const res = await clienteAxios.post("/impresoras", payload);
      mostrarAlerta("Impresora registrada correctamente", "success");
      const newItem = {
        ...payload,
        imp_user: res.data?.imp_user,
        imp_id: res.data?.imp_id,
      };
      table.setRows((prev) => [newItem, ...(prev || [])]);
      table.setHighlight(newItem.imp_id, "new");
      setOpenNuevo(false);
      setNuevo({ ...itemDefault });
    } catch (err) {
      mostrarAlerta(
        err?.response?.data?.msg || "Error al registrar impresora",
        "error",
      );
    }
    setGuardando(false);
  };

  const handleCancelNuevo = () => {
    setOpenNuevo(false);
    setNuevo({ ...itemDefault });
    setErrores({});
  };

  const handleIniciarEditar = (row) => {
    setEditandoId(row.imp_id);
    setEditando({ ...itemDefault, ...row });
    setErroresEdit({});
  };

  const handleActualizar = async () => {
    const erroresValidacion = validarImpresora(editando);
    if (Object.keys(erroresValidacion).length > 0) {
      setErroresEdit(erroresValidacion);
      return;
    }

    setErroresEdit({});
    setGuardando(true);
    try {
      const payload = {
        imp_nombre: editando.imp_nombre.trim(),
        imp_ip: editando.imp_ip.trim(),
      };
      await clienteAxios.put(`/impresoras/${editandoId}`, payload);
      mostrarAlerta("Impresora actualizada correctamente", "success");
      table.setRows((prev) =>
        (prev || []).map((r) =>
          r.imp_id === editandoId ? { ...r, ...payload } : r,
        ),
      );
      table.setHighlight(editandoId, "update");
      setEditandoId(null);
      setEditando({ ...itemDefault });
    } catch (err) {
      mostrarAlerta(
        err?.response?.data?.msg || "Error al actualizar impresora",
        "error",
      );
    }
    setGuardando(false);
  };

  const handleCancelEditar = () => {
    setEditandoId(null);
    setEditando({ ...itemDefault });
    setErroresEdit({});
  };

  const handleEliminar = (id) => {
    setConfirmDelete({ open: true, id });
  };

  const handleConfirmDelete = async () => {
    const id = confirmDelete.id;
    setConfirmDelete({ open: false, id: null });
    setEliminando(true);
    try {
      await clienteAxios.delete(`/impresoras/${id}`);
      mostrarAlerta("Impresora eliminada correctamente", "success");
      table.setRows((prev) => (prev || []).filter((r) => r.imp_id !== id));
    } catch (err) {
      mostrarAlerta(
        err?.response?.data?.msg || "Error al eliminar impresora",
        "error",
      );
    }
    setEliminando(false);
  };

  return {
    ...table,
    openNuevo,
    nuevo,
    guardando,
    errores,
    editandoId,
    editando,
    erroresEdit,
    eliminando,
    confirmDelete,
    setOpenNuevo,
    setNuevo,
    setErrores,
    setEditando,
    setErroresEdit,
    handleRegistrar,
    handleCancelNuevo,
    handleIniciarEditar,
    handleActualizar,
    handleCancelEditar,
    handleEliminar,
    handleConfirmDelete,
    setConfirmDelete,
  };
};

export default useImpresora;
